import React, { createContext, useState, useEffect } from 'react';
import ru from '../locales/ru.json';
import en from '../locales/en.json';
export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  const translations = {
    ru,
    en,
  };

  useEffect(() => {
    // Проверяем localStorage при загрузке
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage && ['ru', 'en'].includes(savedLanguage)) {
      setLanguage(savedLanguage);
    } else {
      // Автоопределение языка
      const userLanguage = navigator.language || navigator.userLanguage;
      const defaultLanguage = userLanguage.startsWith('ru') ? 'ru' : 'en';
      setLanguage(defaultLanguage);
    }
  }, []);
  
  const toggleLanguage = () => {
    const newLanguage = language === 'en' ? 'ru' : 'en';
    setLanguage(newLanguage);
    localStorage.setItem('language', newLanguage); // Сохраняем в localStorage
  };

  return (
    <LanguageContext.Provider value={{ language, translations, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};